import { createSelector } from '@reduxjs/toolkit'

import { RootState } from './store'

const getUserSettingsState = (state: RootState) => state?.userSettings

export const getUserLastConversationClientId = createSelector(
  getUserSettingsState,
  (userSettingsState) => userSettingsState?.lastConversationClientId,
)

export const getUserClientListFilters = createSelector(
  getUserSettingsState,
  (userSettingsState) => userSettingsState?.clientListFilters,
)

export const getUserClientListSorting = createSelector(
  getUserSettingsState,
  (userSettingsState) => userSettingsState?.clientListSorting,
)
